export default __webpack_public_path__ + "./image/a5cd0a89a11e0d5c73ba0e790ad20da8.png";